"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.McpApprovalPolicy = void 0;
exports.McpApprovalPolicy = {
    AutoApproveAll: "auto_approve_all",
    RequireApprovalAll: "require_approval_all",
    RequireApprovalPerTool: "require_approval_per_tool",
};
